import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=960057ec&scoped=true"
import script from "./Tag.vue?vue&type=script&setup=true&lang=js"
export * from "./Tag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Tag.vue?vue&type=style&index=0&id=960057ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960057ec",
  null
  
)

export default component.exports